module.exports = __webpack_public_path__ + "static/media/18ECA12.6d17e939.jpg";